import type { Pattern, PatternCell } from "../../../../src/lib/audio";

export type ArrangePatternClipboard = {
  kind: "pattern";
  pattern: Pattern;
};

export type ArrangeTrackClipboard = {
  kind: "track";
  cells: PatternCell[];
};

export type ArrangeClipboard = ArrangePatternClipboard | ArrangeTrackClipboard;

let clipboard: ArrangeClipboard | null = null;

export function getArrangeClipboard(): ArrangeClipboard | null {
  return clipboard;
}

export function setArrangeClipboard(next: ArrangeClipboard | null): void {
  clipboard = next;
}

export function hasArrangePatternClipboard(): boolean {
  return clipboard?.kind === "pattern";
}

export function hasArrangeTrackClipboard(): boolean {
  return clipboard?.kind === "track";
}
